import { render, staticRenderFns } from "./customer-loan-request.vue?vue&type=template&id=49331edc&"
import script from "./customer-loan-request.vue?vue&type=script&lang=js&"
export * from "./customer-loan-request.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports